import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation/Navigation';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Products from './pages/Products/Products';
import './App.css';

const ScrollToHash = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash || hash === '#top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    // wait a frame so the target section exists after a route change
    const id = requestAnimationFrame(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    });
    return () => cancelAnimationFrame(id);
  }, [pathname, hash]);
  return null;
};

/* Reveal-on-scroll: observes common card/section elements and fades them
   in as they enter the viewport. A MutationObserver picks up elements
   added after mount (e.g. when switching service tabs). */
const REVEAL_SELECTOR = [
  '.sec-head', '.section-header',
  '.bento-card', '.process-step', '.spotlight-item', '.quote-card',
  '.ab-value-card', '.ab-stat-card', '.ab-timeline-item', '.ab-cap-pill',
  '.srv-all-card', '.srv-why-card',
  '.ct-card', '.ct-faq-item',
].join(',');

const ScrollReveal = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('rvl-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -36px 0px' }
    );

    const attach = (root) => {
      const found = [];
      if (root.matches && root.matches(REVEAL_SELECTOR)) found.push(root);
      if (root.querySelectorAll) found.push(...root.querySelectorAll(REVEAL_SELECTOR));
      found.forEach((el) => {
        if (el.classList.contains('rvl-in')) return;
        if (!el.classList.contains('rvl')) {
          el.classList.add('rvl');
          const siblings = el.parentElement ? Array.from(el.parentElement.children) : [];
          el.style.transitionDelay = `${(Math.max(siblings.indexOf(el), 0) % 6) * 60}ms`;
        }
        io.observe(el);
      });
    };

    attach(document.body);

    const mo = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === 1) attach(node);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      io.disconnect();
      mo.disconnect();
    };
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <div className="App" id="top">
        <ScrollToHash />
        <ScrollReveal />
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/products" element={<Products />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
